import { TeamOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Tag } from 'components/ui';

export const CollaboratorsCompactIcon = styled(TeamOutlined)`
  font-size: 1.25rem;
`;

export const CollaboratorsTag = styled(Tag)`
  max-width: 100%;
  white-space: normal;
`;

export const WorkOrderNumberAndCollabIcon = styled(TeamOutlined)`
  margin-right: 5px;
  font-size: 1.15em;
`;

export const WorkNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
